module.exports = __webpack_public_path__ + "img/coin_turn.03199e8f.gif";